<template>
  <div class="main-content-container container-fluid px-4">
    <div class="page-header row no-gutters py-4">
      <div class="col-8 col-sm-4 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle">Vtex \ <span class="ActiveURL">Brand And CatagoryView</span></span>
        <!-- <h3 class="page-title">upload Syncc data</h3> -->
      </div>
    </div>
  <div class="row">
    <d-card class="card-small col-lg-6">
      <!-- Card Header -->
      <d-card-header class="border-bottom row">
        <h6 class="m-0">Brand Master</h6>

          <button
            class="btn btn-md btn-primary" @click="DownloadBrand()"
            style="margin-left: 400px;background-color:white;margin-top:-30px;color:black;"
          ><download-excel :data="BrandMasterUpload.Masters.BrandMaster"  name="Brand"><span style="marige-top:10px;" > Download </span>   </download-excel>  </button>


        
        
      </d-card-header>

      <d-list-group flush>
        <d-list-group-item class="p-3">
          <d-row> 
            <d-col>        
              <d-form id="pricing">
                <d-form-row>
                 
               
         <div class="card-body p-0 pb-3 text-center">
            <div class="row">
              <div class="col">
                <div class="grid-row" layout="row top-stretch">
                  <div class="grid-cell">
                    <paginator
                      :source="BrandMasterUpload.Masters.BrandMaster"
                      :filter="BrandMasterUpload.GridInfo.BrandMasterDetailsInfoGrid.AdditionalInfo.filter"
                      :page-size="BrandMasterUpload.GridInfo.BrandMasterDetailsInfoGrid.AdditionalInfo.pageSize"
                      data-intro="Use the paginator to page data for easier viewing"
                      data-step="10"
                      data-position="top"
                    >
                      <template scope="page">
                        <datatable
                          id="data-table-main"
                          :source="page.data"
                          :filterable="false"
                          :striped="BrandMasterUpload.GridInfo.BrandMasterDetailsInfoGrid.AdditionalInfo.striped"
                          :editable="BrandMasterUpload.GridInfo.BrandMasterDetailsInfoGrid.AdditionalInfo.editable"
                          :line-numbers="BrandMasterUpload.GridInfo.BrandMasterDetailsInfoGrid.AdditionalInfo.lineNumbers"
                        >
                          <datatable-column
                            v-for="column in BrandMasterUpload.GridInfo.BrandMasterDetailsInfoGrid.columns"
                            :id="column.id"
                            :label="column.label"
                            :width="column.width"
                            :sortable="column.sortable"
                            :groupable="column.groupable"
                            :formatter="column.formatter"
                          ></datatable-column>
                              <template slot="id" scope="cell">
                            <label
                              for="id"
                              style="width:100% !important"
                              class="Grid-field align-left form-control-sm gridLink"
                            >{{cell.row.id}}</label>
                          </template>
                          <!-- <template slot="ProfitAmount" scope="cell">
                                        <label for="ProfitAmount" style="width:100% !important" :Id="cell.row.Id + '_max'" class="Grid-field align-left form-control-sm"> {{cell.row.ProfitAmount}} </label>
                          </template>-->
                          <template slot="name" scope="cell">
                            <label
                              for="name"
                              style="width:100% !important"
                              class="Grid-field align-left form-control-sm"
                            >{{cell.row.name}}</label>
                          </template>
                          <!-- <template slot="Status" scope="cell">
                                        <label for="Status" style="width:100% !important" :Id="cell.row.Id + '_max'" class="Grid-field align-left form-control-sm"> {{cell.row.Status}} </label>
                          </template>-->
                          <!-- <template slot="Status.Name" scope="cell">
                            <label
                              for="Status"
                              style="width:100% !important"
                              class="Grid-field align-left form-control-sm"
                            >{{cell.row.Status.Name}}</label>
                          </template>-->
                        </datatable>
                      </template>
                    </paginator>
                  </div>
                </div>
              </div>
            </div>
          </div>

                </d-form-row>

                <br />

              </d-form>
            </d-col>
          </d-row>
        </d-list-group-item>
      </d-list-group>
    </d-card>

    <d-card class="card-small col-lg-6">
      <!-- Card Header -->
      <d-card-header class="border-bottom row">
        <h6 class="m-0">Category Master</h6>

  <button
            class="btn btn-md btn-primary" @click="DownloadBrand()"
            style="margin-left: 400px;background-color:white;margin-top:-30px;color:black;"
          ><download-excel :data="BrandMasterUpload.Masters.CategoryMaster"  name="Brand"><span style="marige-top:10px;" > Download </span>   </download-excel>  </button>
      </d-card-header>

      <d-list-group flush>
        <d-list-group-item class="p-3">
          <d-row> 
            <d-col>        
              <d-form id="pricing">
                <d-form-row>
                 
      
            
         <div class="card-body p-0 pb-3 text-center">
            <div class="row">
              <div class="col">
                <div class="grid-row" layout="row top-stretch">
                  <div class="grid-cell">
                    <paginator
                      :source="BrandMasterUpload.Masters.CategoryMaster"
                      :filter="BrandMasterUpload.GridInfo.CategoryMasterDetailsInfoGrid.AdditionalInfo.filter"
                      :page-size="BrandMasterUpload.GridInfo.CategoryMasterDetailsInfoGrid.AdditionalInfo.pageSize"
                      data-intro="Use the paginator to page data for easier viewing"
                      data-step="10"
                      data-position="top"
                    >
                      <template scope="page">
                        <datatable
                          id="data-table-main"
                          :source="page.data"
                          :filterable="false"
                          :striped="BrandMasterUpload.GridInfo.CategoryMasterDetailsInfoGrid.AdditionalInfo.striped"
                          :editable="BrandMasterUpload.GridInfo.CategoryMasterDetailsInfoGrid.AdditionalInfo.editable"
                          :line-numbers="BrandMasterUpload.GridInfo.CategoryMasterDetailsInfoGrid.AdditionalInfo.lineNumbers"
                        >
                          <datatable-column
                            v-for="column in BrandMasterUpload.GridInfo.CategoryMasterDetailsInfoGrid.columns"
                            :id="column.id"
                            :label="column.label"
                            :width="column.width"
                            :sortable="column.sortable"
                            :groupable="column.groupable"
                            :formatter="column.formatter"
                          ></datatable-column>
                          <template slot="id" scope="cell">
                            <label
                              for="id"
                              style="width:100% !important"
                              class="Grid-field align-left form-control-sm gridLink"
                            >{{cell.row.id}}</label>
                          </template>
                          <!-- <template slot="ProfitAmount" scope="cell">
                                        <label for="ProfitAmount" style="width:100% !important" :Id="cell.row.Id + '_max'" class="Grid-field align-left form-control-sm"> {{cell.row.ProfitAmount}} </label>
                          </template>-->
                          <template slot="name" scope="cell">
                            <label
                              for="name"
                              style="width:100% !important"
                              class="Grid-field align-left form-control-sm"
                            >{{cell.row.name}}</label>
                          </template>
                          <!-- <template slot="Status" scope="cell">
                                        <label for="Status" style="width:100% !important" :Id="cell.row.Id + '_max'" class="Grid-field align-left form-control-sm"> {{cell.row.Status}} </label>
                          </template>-->
                          <!-- <template slot="Status.Name" scope="cell">
                            <label
                              for="Status"
                              style="width:100% !important"
                              class="Grid-field align-left form-control-sm"
                            >{{cell.row.Status.Name}}</label>
                          </template>-->
                        </datatable>
                      </template>
                    </paginator>
                  </div>
                </div>
              </div>
            </div>
          </div>

                </d-form-row>

                <br />

              </d-form>
            </d-col>
          </d-row>
        </d-list-group-item>
      </d-list-group>
    </d-card>
  </div>




    <div v-if="BrandMasterUpload.PageLoad" class="load-container load1"><div class="loader">Loading...</div></div>
  </div>
</template>
<script>
import Utilities from "@/Utilities/Utilities";
import axios from "axios";
import xlsx from "xlsx";
import XLSX from 'xlsx';
export default {
  name: 'BrandMasterUpload',
   data() {
    return {
      BrandMasterUpload: {
        PageType: "Master",
        PageLoad: false, 
        DataModel: {
          Data: {
             QueryString:null,
            BrandMaster:null,
            Token:null,
            Curd:null,
            CreatedBy:0
          },
          UIData: {
            mySteps:['Step 1', 'Step 2', 'Step 3'],
            currentStep:0,
            Template:[],
            minMaxList:[],
            RejectedList:[],
            AvailablityTemplate:[],
            BrandMasterList:[],
            AvailablityList:[],
            AvailablityTemplateCount:0,
            TemplateIsAvailable :false,
            FileName:"Template",
            LoadedFileName:"",
            AvailabilityFileName:"Template",
            UploadedDataCount:0
          },
        },
        GridInfo: {
          BrandMasterDetailsInfoGrid: {
            filterInfo: {
              PageSize: 0,
              PageNumber: 0,
              HotelId: 0,
              CustomerName: null,
            },
            AdditionalInfo: {
              striped: true,
              editable: false,
              lineNumbers: false,
              filter: null,
              currency: "USD",
              dateFormat: "D MMMM YYYY",
              selected: [],
              pageSize: 15,
              totalRows: 0,
            },
            columns: [
              {
                id: "id",
                label: "Brand Id",
                width: null,
                sortable: true,
                groupable: true,
                aggregators: [],
              },

              {
                id: "name",
                label: "Brand Name",
                width: null,
                sortable: true,
                groupable: true,
                aggregators: [],
              },
            ],
          },
          CategoryMasterDetailsInfoGrid: {
            filterInfo: {
              PageSize: 0,
              PageNumber: 0,
              HotelId: 0,
              CustomerName: null,
            },
            AdditionalInfo: {
              striped: true,
              editable: false,
              lineNumbers: false,
              filter: null,
              currency: "USD",
              dateFormat: "D MMMM YYYY",
              selected: [],
              pageSize: 15,
              totalRows: 0,
            },
            columns: [
              {
                id: "CategoryId",
                label: "Category Id",
                width: null,
                sortable: true,
                groupable: true,
                aggregators: [],
              },

              {
                id: "CategoryName",
                label: "Category Name",
                width: null,
                sortable: true,
                groupable: true,
                aggregators: [],
              },
            ],
          },
        },
        SessionInfo: {
          PageInfo: {
            userId: 0,
          },
        },

        ErrorInfo: [
          {
            ErrorID: 1,
            ErrorName: "",
            ErrorMessage: "",
          },
        ],

        Masters: {
          BrandMaster:[],
          CategoryMaster:[],

          PanelList:[
            {
              Name : "Amazon UAEDirect",
              Country:"UAEDirect",
              Panel:"Amazon"
            },
            {
              Name : "Amazon India",
              Country:"India",
              Panel:"Amazon"
            },
            {
              Name : "Amazon IndiaDirect",
              Country:"IndiaDirect",
              Panel:"Amazon"
            },
            {
              Name : "Amazon Australia",
              Country:"Australia",
              Panel:"Amazon"
            },
            {
              Name : "Amazon UAE",
              Country:"UAE",
              Panel:"Amazon"
            },
            {
              Name : "Amazon Mexico",
              Country:"Mexico",
              Panel:"Amazon"
            },
            {
              Name : "Amazon Canada",
              Country:"Canada",
              Panel:"Amazon"
            },
            {
              Name : "Amazon Brazil",
              Country:"Brazil",
              Panel:"Amazon"
            },
            {
              Name : "Amazon Singapore",
              Country:"Singapore",
              Panel:"Amazon"
            },
            {
              Name : "Amazon KSA",
              Country:"KSA",
              Panel:"Amazon"
            },
            {
              Name : "Jokoka",
              Country:"UAE",
               Panel:"Jokoka"
            },
            {
              Name : "StoreUS",
              Country:"UAE",
               Panel:"StoreUS"
            },
            {
              Name : "Noon UAE",
              Country:"UAE",
              Panel:"Noon"
            },
            {
              Name : "Noon KSA",
              Country:"KSA",
              Panel:"Noon"
            }
          ]
        },
      },
    };
  },

  mounted(){
      this.BrandMasterUpload.SessionInfo.PageInfo.userId = sessionStorage.getItem("UserId");
       this.BrandMasterUpload.DataModel.Data.CreatedBy = sessionStorage.getItem("UserId");
       this.GetBrandMasterDetails();
       this.ListCategoryMaster();
  },
  methods: {
 
 
      GetBrandMasterDetails(){
      let vm = this;
      var Token = sessionStorage.getItem("Token");
      this.BrandMasterUpload.DataModel.Data.Token = Token;
      this.BrandMasterUpload.DataModel.Data.CRUD = "ListBrandMaster";
      this.BrandMasterUpload.DataModel.UIData.UploadStatus = false;
      this.BrandMasterUpload.DataModel.UIData.RejectedList=[];
      var dataString = JSON.stringify(vm.BrandMasterUpload.DataModel.Data);
       vm.BrandMasterUpload.PageLoad = true;
       vm.BrandMasterUpload.DataModel.UIData.UploadedDataCount = 0;
      axios.post("APIScript/PHP/APIService/SynccentricScrap/SynccentricScrap.php",dataString)
        .then(function (response) {
          if (response.data.ErrorInfo == null) {
            vm.BrandMasterUpload.PageLoad = false;
            vm.BrandMasterUpload.Masters.BrandMaster = response.data.Result

          }
        })
        .catch(function (response) {
          console.log(response);  
          vm.BrandMasterUpload.PageLoad = false;
          vm.$swal.fire("Oops", "Something went worng", "error");
        });
    
      vm.BrandMasterUpload.DataModel.UIData.UploadStatus = true;
      },

      DownloadBrand()
      {
        
      },

      DownloadCategory()
      {
        
      },

      ListCategoryMaster(){
      let vm = this;
      var Token = sessionStorage.getItem("Token");
      this.BrandMasterUpload.DataModel.Data.Token = Token;
      this.BrandMasterUpload.DataModel.Data.CRUD = "ListCategoryMaster";
      this.BrandMasterUpload.DataModel.UIData.UploadStatus = false;
      this.BrandMasterUpload.DataModel.UIData.RejectedList=[];
      var dataString = JSON.stringify(vm.BrandMasterUpload.DataModel.Data);
       vm.BrandMasterUpload.PageLoad = true;
       vm.BrandMasterUpload.DataModel.UIData.UploadedDataCount = 0;
      axios.post("APIScript/PHP/APIService/SynccentricScrap/SynccentricScrap.php",dataString)
        .then(function (response) {
          if (response.data.ErrorInfo == null) {
            vm.BrandMasterUpload.PageLoad = false;
            vm.BrandMasterUpload.Masters.CategoryMaster = response.data.Result

          }
        })
        .catch(function (response) {
          console.log(response);  
          vm.BrandMasterUpload.PageLoad = false;
          vm.$swal.fire("Oops", "Something went worng", "error");
        });
    
      vm.BrandMasterUpload.DataModel.UIData.UploadStatus = true;
      },

 
  }
}
</script>